import React from 'react';
import styled, { css } from 'styled-components';

import { formatDate } from '@src/common';
import { LayoutColors } from '@src/core/theme';
import { device } from '@src/common/breakpoints';
import { BodyRegularSemiBold, Heading4, Heading6 } from '@src/fonts/typography/Typography';
import useTranslate from '@src/i18n/useTranslate';

type SaleDateProps = {
  scheduleDate: string | null;
  scheduleTimeMinutes: string | null;
};

export const SaleDate = ({ scheduleDate, scheduleTimeMinutes }: SaleDateProps) => {
  const { i18n } = useTranslate();
  const date = scheduleDate ? formatDate(scheduleDate) : '';

  if (date && !scheduleTimeMinutes) {
    return <span>{date}</span>;
  }

  if (date && scheduleTimeMinutes) {
    return (
      <>
        <span>{date}</span>
        <span>{scheduleTimeMinutes}</span>
      </>
    );
  }

  return <span>{i18n('account_sale_item_without_date')}</span>;
};

export const Wrapper = styled.article`
  width: 100%;
`;

export const Container = styled.section`
  width: 100%;
  max-width: 710px;
  margin: 0 auto;
  margin-bottom: 16px;

  background: ${LayoutColors.gray};
  border-radius: 8px;
  padding: 16px;

  ${device.smallTablet} {
    padding: 24px;

    h1 {
      ${Heading4};
    }
  }

  h1 {
    ${Heading6}
    color: ${LayoutColors.blackDark};
    width: 100%;

    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${LayoutColors.grayMain};
  }
`;

export const baseButton = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;

  ${BodyRegularSemiBold};
  border-radius: 4px;
  padding: 10px 16px !important;
  cursor: pointer;

  ${device.smallTablet} {
    width: fit-content;
  }
`;
